import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../../../../../components/LazyWidgets/Card';
import Modal from '../../../../../../components/LazyWidgets/Modal';
import BigText from '../../../../../../components/LazyWidgets/BigText';
import Spinner from '../../../../../../components/LazyWidgets/Spinner';
import Button from '../../../../../../components/LazyWidgets/Button';
import s from './reflectionCard.module.css';
import style from '../../skillsOverviewReport.module.css';
import { getConfigObject } from '../../../../../util/config';

function ReflectionCard(props) {
  const { id, loading } = props;

  const { DASHBOARDS_ENABLED_SKILLS_REFLECTION_SUMMARY, DASHBOARDS_ENABLED_111 } = getConfigObject();

  let reflectionCard = <Spinner className={style.skillsSpinner} />;

  const handleButtonClick = () => {
    props.onTabChange('reports/type/reflections');
  };

  if (!loading) {
    const { data: { disagree, total } } = props;
    reflectionCard = (
      <div>
        <h1 className={s.mainMessage}> No students have submitted reflections. </h1>
        <div className={s.bottomText}>As students submit reflections, you can see how confident they are that they understand the assignment.</div>
      </div>
    );

    if (total !== 0) {
      const reflection = Math.round((disagree / total) * 100);
      reflectionCard = (
        <div>
          <Modal
            className={s.rcModalContainer}
            trigger={<div>
              <button className={s.howLink} role="link">How is this calculated?</button>
            </div>}
          >
            <Modal.Header>
              <p className={s.rcModalHeader}>Reflection Snapshot</p>
            </Modal.Header>
            <Modal.Content id="my-modal-id" className={s.rcModalContent}>
              <p>This report displays the percentage of students on the most recent assignment who indicated whether they disagree or strongly disagree with the reflection prompt “I know the criteria being used to give me feedback.”</p>
            </Modal.Content>
          </Modal>
          <div className={s.percentage}>
            <BigText className={s.bigNumber} text={`${reflection}%`} />
            <span>
              of students indicated they <span className={s.bold}>disagreed</span> or
              <span className={s.bold}> strongly disagreed</span> on the last draft.
            </span>
          </div>
          {DASHBOARDS_ENABLED_111 && DASHBOARDS_ENABLED_SKILLS_REFLECTION_SUMMARY &&
            <div>
              <Button onClick={handleButtonClick} theme="secondary">View Details</Button>
            </div>}
        </div>
      );
    }
  }

  return (
    <Card
      id={id}
      className={s.reflectionCard}
      padding
    >
      <h2>
        Reflection Snapshot: I understand the criteria that will be used to provide me feedback.
      </h2>
      {reflectionCard}
    </Card>
  );
}

ReflectionCard.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.object,
  loading: PropTypes.bool,
  onTabChange: PropTypes.func,
};

export default ReflectionCard;
